"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBoolean = void 0;
exports.isBoolean = (value) => typeof value === "boolean";
//# sourceMappingURL=is-boolean.js.map